import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState }) => css`
        padding: ${displayState?.padding ?? '10px'};;
        border-radius: ${displayState?.borderRadius ?? 'unset'};
        background-color: ${displayState?.background ? displayState?.background : `${window?.settings?.primary_color ?? '#1DBD6B'}0D`};
        width: ${displayState?.width ?? ''};
        height: ${displayState?.height ?? ''};
        border: 1px solid ${displayState?.borderColor ?? '#E7EBEB'};
  `}
`;

export default Wrapper(template);
